const isValidIpv4Address = (value) => {
  const octets = value.trim().split(".");
  return (
    octets.length === 4 &&
    octets.every(
      (octet) =>
        /^\d{1,3}$/.test(octet) &&
        Number(octet) >= 0 &&
        Number(octet) <= 255
    )
  );
};

const isValidIpv6Address = (value) => {
  const address = value.trim();
  if (!address.includes(":")) return false;

  const compressedParts = address.split("::");
  if (compressedParts.length > 2) return false;

  const segments = compressedParts.flatMap((part) =>
    part === "" ? [] : part.split(":")
  );
  if (segments.some((segment) => segment === "")) return false;

  const ipv4Index = segments.findIndex((segment) => segment.includes("."));
  if (
    ipv4Index !== -1 &&
    (ipv4Index !== segments.length - 1 ||
      !isValidIpv4Address(segments[ipv4Index]))
  ) {
    return false;
  }

  const hexadecimalSegments =
    ipv4Index === -1 ? segments : segments.slice(0, -1);
  if (
    !hexadecimalSegments.every((segment) => /^[\da-f]{1,4}$/i.test(segment))
  ) {
    return false;
  }

  const segmentCount =
    hexadecimalSegments.length + (ipv4Index === -1 ? 0 : 2);
  return compressedParts.length === 2 ? segmentCount < 8 : segmentCount === 8;
};

export const isValidIpAddress = (value = "") =>
  isValidIpv4Address(value) || isValidIpv6Address(value);

export const parseIpAddresses = (value = "") =>
  value
    .split(/[\s,]+/)
    .map((address) => address.trim())
    .filter(Boolean);

export const isValidIpAddressList = (value = "") =>
  parseIpAddresses(value).every(isValidIpAddress);
